// import { Exercise, SetExercise, Workout, SessionSet } from "@api/entities";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import sessionStorage from 'redux-persist/lib/storage';
import { ContextEnum } from "src/_shared/enums/context.enum";
import { Exercise, SessionSet, SetExercise, Workout } from "src/api/entities";
// import { ContextEnum } from "@enums/context.enum";

export interface SelectableWorkoutGroup {
    label: string;
    value: string;
}

export interface SetExerciseCreateUpdate {
    uuid: string;
    name: string;
    group: string;
}


export interface WorkoutSetCreatUpdate {
    exercise: SetExercise;
    uuid?: string;
    weight?: string;
    reps?: string;
    rest?: string;
}

export interface WorkoutCreateUpdate {
    name: string;
    sets: WorkoutSetCreatUpdate[]
}


export interface WorkoutState {
    workoutCreateUpdate: WorkoutCreateUpdate;
    selectedGroup: string;
    setCreateUpdate: WorkoutSetCreatUpdate
    context: ContextEnum;
    workouts: Workout[];
    workoutsDashboard: Workout[];
    workoutSets: SessionSet[];
}

const initialWorkoutCreateUpdate: WorkoutCreateUpdate = {
    name: "",
    sets: []
};

const initialState: WorkoutState = {
    setCreateUpdate: {
        exercise: {}
    },
    workoutsDashboard: [],
    workoutCreateUpdate: initialWorkoutCreateUpdate,
    workouts: [],
    context: ContextEnum.CREATE,
    selectedGroup: "",
    workoutSets: []
};

export const workoutPersistedConfig = {
    key: 'workout',
    storage: sessionStorage,
    whitelist: ['workoutCreateUpdate', 'workouts', 'context', 'selectedGroup', 'setCreateUpdate'],
};

export const workoutSlice = createSlice({
    name: "workout",
    initialState: initialState,
    reducers: {
        setWorkoutName(state, action: PayloadAction<{ value: string }>) {
            state.workoutCreateUpdate.name = action.payload.value;
        },
        setWorkoutExercise(state, action: PayloadAction<{ value: Exercise }>) {
            state.setCreateUpdate.exercise = {
                group: action.payload.value.group,
                name: action.payload.value.name,
                uuid: action.payload.value.uuid,
            }
        },
        setWorkoutSetFormValue(state, action: PayloadAction<{ key: keyof WorkoutSetCreatUpdate; value: string }>) {
            state.setCreateUpdate[action.payload.key] = action.payload.value;
        },
        selectGroup(state, action: PayloadAction<{ value: SelectableWorkoutGroup }>) {
            state.selectedGroup = action.payload.value.value;
        },
        setWorkoutSetItems(state, action: PayloadAction<{ value: SessionSet[] }>) {
            state.workoutSets = action.payload.value;
        },
        setWorkoutItems(state, action: PayloadAction<{ value: Workout[] }>) {
            state.workouts = action.payload.value;
        },
        setWorkoutDashboardItems(state, action: PayloadAction<{ value: Workout[] }>) {
            state.workoutsDashboard = action.payload.value;
        },
        resetWorkoutCreateUpdate(state) {
            state.workoutCreateUpdate = initialState.workoutCreateUpdate;
        },
    },
});

export const { 
    setWorkoutSetFormValue,
    setWorkoutName,
    setWorkoutExercise,
    resetWorkoutCreateUpdate,
    selectGroup,
    setWorkoutSetItems,
    setWorkoutItems,
    setWorkoutDashboardItems
 } = workoutSlice.actions;

export const workoutReducer = workoutSlice.reducer;
